import axios from "axios";

import { ISimuladorResponse } from "../../../pages/RespostasSimulador/interfaces";

import { urlHttpGov } from "../../urls";
import { getToken } from "../../LStorage/token";

class ItemService {
  private readonly baseURL = `${urlHttpGov}/simulador-inteligente/resposta`;

  async createResponse(input: unknown): Promise<ISimuladorResponse> {
    const { data } = await axios.post(this.baseURL, { resposta: input });

    return data;
  }

  async updateResponse(
    responseId: string,
    input: unknown
  ): Promise<unknown> {

    const { data } = await axios.patch(`${this.baseURL}/${responseId}`, {
      resposta: input
    });

    return data;
  }

  async finishResponse(responseId: string): Promise<void> {
    await axios.patch(`${this.baseURL}/${responseId}/finalizar`);
  }

  async getResponses(): Promise<ISimuladorResponse[]> {
    const { data } = await axios.get(`${this.baseURL}`, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    });

    return data.map((e: ISimuladorResponse) => ({
      ...e,
      status: e.fluxo_finalizado_em ? "finalizado" : "em_preenchimento"
    }));
  }

  async deleteResponse(responseId: string): Promise<void> {
    await axios.delete(`${this.baseURL}/${responseId}`);
  }
}

export default new ItemService();
